// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_GO_BOTTOM = "Dol\u016f";
export const BZ2_GO_NEXT = "Dal\u0161\u00ed";
export const BZ2_GO_PREVIOUS = "P\u0159edchoz\u00ed";
export const BZ2_GO_TOP = "Nahoru";
export const CANCEL = "Zru\u0161";
export const GO_PAGING = "Jdi";
export const OUT_OF = "z";
export const PAGE = "Strana";
